"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FileEmptyCard = void 0;
/*---------------------------------------------------------------------------------------------
 * Copyright (c) Bentley Systems, Incorporated. All rights reserved.
 * See LICENSE.md in the project root for license terms and full copyright notice.
 *--------------------------------------------------------------------------------------------*/
const React = __importStar(require("react"));
const index_js_1 = require("../utils/index.js");
const classnames_1 = __importDefault(require("classnames"));
const FileUploadCard_js_1 = __importDefault(require("./FileUploadCard.js"));
const FileEmptyCardIcon = React.forwardRef((props, ref) => {
    const { children, className, ...rest } = props;
    return (React.createElement("span", { className: (0, classnames_1.default)('iui-file-card-empty-icon', className), ref: ref, ...rest }, children !== null && children !== void 0 ? children : React.createElement(index_js_1.SvgUpload, null)));
});
const FileEmptyCardText = React.forwardRef((props, ref) => {
    const { children, className, ...rest } = props;
    return (React.createElement("span", { className: (0, classnames_1.default)('iui-file-card-empty-action', className), ref: ref, ...rest }, children));
});
/**
 * Empty file card to be used with the `FileUploadCard` component when no file has been uploaded.
 * @example
 * <FileEmptyCard />
 * <FileEmptyCard>
 *   <FileEmptyCard.Icon>
 *     <SvgSmileySadVery />
 *   </FileEmptyCard.Icon>
 *   <FileEmptyCard.Text>
 *     <FileUploadCard.InputLabel>
 *       Custom Label Text
 *     </FileUploadCard.InputLabel>
 *     <div>Custom Description Text</div>
 *   </FileEmptyCard.Text>
 * </FileEmptyCard>
 */
exports.FileEmptyCard = Object.assign(React.forwardRef((props, ref) => {
    const { children, className, ...rest } = props;
    return (React.createElement("div", { className: (0, classnames_1.default)('iui-file-card-empty', className), ref: ref, ...rest }, children !== null && children !== void 0 ? children : (React.createElement(React.Fragment, null,
        React.createElement(exports.FileEmptyCard.Icon, null),
        React.createElement(exports.FileEmptyCard.Text, null,
            React.createElement(FileUploadCard_js_1.default.InputLabel, null, "Choose a file"),
            React.createElement("div", null, "to upload."))))));
}), {
    Icon: FileEmptyCardIcon,
    Text: FileEmptyCardText,
});
exports.default = exports.FileEmptyCard;
